/** Detect 2:1 equirectangular image aspect ratio (tolerance ±5%) */
export function isEquirectangular(width: number, height: number): boolean {
  if (!width || !height) return false;
  const ratio = width / height;
  return Math.abs(ratio - 2) < 0.1;
}
